import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RmaUrlsService } from '@rma/generic/util/environment';
import { rmaIcons } from '../domain/rma-icons.const';

@Injectable({ providedIn: 'root' })
export class CustomIconService {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly rmaUrls = inject(RmaUrlsService);
  private readonly sanitizer = inject(DomSanitizer);

  public static svgIcons = rmaIcons;

  public register(): void {
    const icons = [...rmaIcons];
    icons.forEach((icon) =>
      this.iconRegistry.addSvgIcon(icon.name, this.sanitizer.bypassSecurityTrustResourceUrl(this.rmaUrls.imageUrl(icon.location))),
    );
  }
}
